// Keys for local storage.
export const KEY_SETTINGS = 'sdl.tridion.openid.settings';
export const KEY_REDIRECT = 'sdl.tridion.openid.redirect';
export const KEY_ACCESS_TOKEN = 'sdl.tridion.openid.accesstoken';
export const KEY_OPENID_SETTINGS = 'sdl.tridion.openid.settings';
